import { forwardRef } from "react";

// Material Dashboard 2 PRO React contexts
import { useMaterialUIController } from "context";

const AsteriskLabel = forwardRef(({ postfix, children, ...rest }, ref) => {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  return (
    <div
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
      ref={ref}
    >
      {postfix ? null : children}
      <span
        style={{
          ...(postfix ? { marginRight: "5px" } : { marginLeft: "5px" }),
          color: darkMode ? "#909191" : "#6F6E6E",
        }}
      >
        ✱{/* "∗" -> for light & "✱" -> for bold */}
      </span>
      {postfix ? children : null}
    </div>
  );
});

export default AsteriskLabel;
